export type CoalescingAsyncRunner = {
  request: () => Promise<void>;
};

export function createCoalescingAsyncRunner(
  run: () => Promise<void>
): CoalescingAsyncRunner {
  let inFlight: Promise<void> | null = null;
  let rerunRequested = false;

  const drain = async (): Promise<void> => {
    rerunRequested = false;
    try {
      await run();
    } catch (error) {
      console.error('Coalesced async run failed:', error);
    }
    if (rerunRequested) {
      await drain();
    }
  };

  const request = (): Promise<void> => {
    if (inFlight) {
      rerunRequested = true;
      return inFlight;
    }
    inFlight = drain().finally(() => {
      inFlight = null;
    });
    return inFlight;
  };

  return { request };
}
